import React, { forwardRef } from 'react';
import { Box } from '@fiverr-private/theme';

interface PillButtonProps {
    isActive: boolean;
    onClick?: () => void;
    children: React.ReactNode;
    className?: string;
    iconOnly?: boolean;
}

export const PillButton = forwardRef<HTMLButtonElement, PillButtonProps>(
    ({ isActive, onClick, children, className, iconOnly = false }, ref) => (
        <Box
            ref={ref}
            as="button"
            type="button"
            onClick={onClick}
            className={className}
            display="flex"
            alignItems="center"
            justifyContent="center"
            gap="2"
            height="40px"
            paddingY="1"
            {...(iconOnly ? { width: '40px' } : { paddingX: '4' })}
            backgroundColor="white"
            borderStyle="solid"
            borderRadius="circle"
            borderWidth="sm"
            borderColor={isActive ? 'grey_1200' : { default: 'grey_400', hover: 'grey_1200' }}
            cursor="pointer"
            {...(isActive
                ? {
                      outlineStyle: 'solid',
                      outlineWidth: 'sm',
                      outlineOffset: '0',
                      outlineColor: 'grey_1200',
                  }
                : {})}
        >
            {children}
        </Box>
    )
);

PillButton.displayName = 'PillButton';
